<script setup>
import { reactive } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { useForm, Link } from '@inertiajs/inertia-vue3'
import AuthLayout from "../../Shared/Layouts/Layout";

const form = useForm({
    email: null,
    password: null,
    remember: false,
})

function submit() {
  form.post(route('login', route().params), {
    preserveScroll: true,
    onSuccess: () => console.log('success'),
  });
}
//const layout = AuthLayout;

</script>

<template>
  <div class="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="p-5 bg-gray-100 sm:p-8">
        <div class="-m-3 p-3 flow-root rounded-md hover:bg-gray-100 transition ease-in-out duration-150">
      <span class="flex items-center">
        <span class="text-base font-medium text-gray-900"> Login of Registeer </span>
      </span>
          <span class="mt-1 block text-sm text-gray-500"> Bekijk de geleende producten. </span>
        </div>
      </div>
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <form @submit.prevent="submit" class="space-y-6" action="#" method="POST">
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700"> E-mailadres </label>
            <div class="mt-1">
              <input v-model="form.email" id="email" name="email" type="email" autocomplete="email" required="" placeholder="E-mailadres" class="appearance-none block w-full px-3 py-2 border border-primary rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm" />
              <div v-if="form.errors.email" v-text="form.errors.email" class="text-red-500 text-xs mt-1"></div>
            </div>
          </div>

          <div>
            <label for="password" class="block text-sm font-medium text-gray-700"> Wachtwoord of telefoonnummer </label>
            <div class="mt-1">
              <input v-model="form.password" id="password" name="password" type="password" autocomplete="current-password" required="" placeholder="Wachtwoord" class="appearance-none block w-full px-3 py-2 border border-primary rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm" />
            </div>
          </div>

          <div class="flex items-center justify-between">
            <div class="flex items-center hover:opacity-80">
              <input v-model="form.remember" id="remember-me" name="remember-me" type="checkbox" class="h-4 w-4 text-primary focus:ring-primary border-primary rounded" />
              <label for="remember-me" class="ml-2 block text-sm text-primary"> Onthoud mij </label>
            </div>

            <div class="text-sm">
              <Link :href="route('password.forgot.form')" class="font-medium text-primary hover:opacity-80"> Wachtwoord vergeten? </Link>
            </div>
          </div>

          <div>
            <button type="submit" :disabled="form.processing" class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:opacity-80 focus:outline-none">
              <svg v-if="form.processing" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span v-text="form.processing ? 'Bezig...' : 'Inloggen'"></span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
